<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center animated fadeIn">
        <b-col sm="12" md="10" lg="8" class="text-center">
          <img :src="logo" :alt="logoAlt" class="login-form-image mb-4" />

          <h1 class="mb-4">{{ t("Welcome") }}</h1>

          <b-card no-body class="card-accent-primary p-3 p-sm-4">
            <div
              v-if="isPending"
              class="d-flex justify-content-center align-items-center"
              style="min-height: 200px"
            >
              <Loading />
            </div>

            <div v-else>
              <p class="text-muted mb-4">{{ t("Please choose an option to continue") }}</p>

              <div class="row g-3 justify-content-center">
                <!-- Login Button -->
                <div class="col-auto">
                  <div class="auth-option text-center">
                    <small class="text-muted d-block mb-2">{{
                      t("Already have an account?")
                    }}</small>
                    <b-button :href="loginUrl" variant="primary" size="lg">
                      <i class="fas fa-sign-in-alt me-2"></i>
                      {{ t("Login") }}
                    </b-button>
                  </div>
                </div>

                <!-- Register Button -->
                <div v-if="data?.parents?.allowSelfRegistration" class="col-auto">
                  <div class="auth-option text-center">
                    <small class="text-muted d-block mb-2">{{ t("Create a new account") }}</small>
                    <b-button :to="{ name: 'auth.register' }" variant="outline-primary" size="lg">
                      <i class="fas fa-user-plus me-2"></i>
                      {{ t("Register") }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LOGIN_URL } from "@/config";

import { computed, watchEffect } from "vue";
import { usePublicTenantSettings } from "@/modules/settings/queries/usePublicTenantSettings";
import { useI18n } from "vue-i18n";
import Loading from "@/components/Loading.vue";

// forceEnabled: must load even for a visitor "authenticated" on another tenant's stale cookie
const { data, isPending } = usePublicTenantSettings({ forceEnabled: true });
const { t } = useI18n();

const logo = computed(() => "/img/obiado.svg");
const logoAlt = computed(() => "Obiado logo");
const loginUrl = computed(() => `${LOGIN_URL}`);

watchEffect(() => {
  if (isPending.value) {
    return;
  }
  // if registration is disabled, redirect to login page
  if (!data.value?.parents?.allowSelfRegistration && loginUrl.value) {
    window.location.href = loginUrl.value;
  }
});
</script>

<style scoped lang="scss">
.auth-option .btn-outline-primary:hover {
  color: white;
}
</style>
